<div class="loader-container">
  <mat-spinner diameter="45"></mat-spinner>
  <p>{{ msg }}</p>
</div>
